export default function logout(role = "Client"){ //Default role
    sessionStorage.clear()
    if(role === "Admin"){
        window.location = "#/Admin"
    }
    else{
        window.location = "/"
    }
    
}